import { gql } from '@apollo/client'

export const History = gql`
    query History($roomId: ID!, $cursor: ID) {
        history(roomId: $roomId, cursor: $cursor) {
            cursor
            events {
                ... on AdminAdded {
                    actor {
                        id
                        username
                        avatar
                    }
                    admin {
                        id
                        username
                        avatar
                    }
                    id
                    room {
                        id
                    }
                    updated
                }
                ... on AdminRemoved {
                    actor {
                        id
                        username
                        avatar
                    }
                    admin {
                        id
                        username
                        avatar
                    }
                    id
                    room {
                        id
                    }
                    updated
                }
                ... on ChatAdded {
                    actor {
                        id
                        username
                        avatar
                    }
                    id
                    room {
                        id
                    }
                    text
                    updated
                }
                ... on ChatRemoved {
                    actor {
                        id
                        username
                        avatar
                    }
                    id
                    room {
                        id
                    }
                    updated
                }
                ... on ChatUpdated {
                    actor {
                        id
                        username
                        avatar
                    }
                    id
                    room {
                        id
                    }
                    text
                    updated
                }
                ... on ChatReaction {
                    actor {
                        id
                        username
                        avatar
                    }
                    chatId
                    emoji
                    id
                    room {
                        id
                    }
                    updated
                }
                ... on ChatReactionRemoved {
                    actor {
                        id
                        username
                        avatar
                    }
                    id
                    room {
                        id
                    }
                    updated
                }
                ... on MemberAdded {
                    actor {
                        id
                        username
                        avatar
                    }
                    id
                    member {
                        id
                        username
                        avatar
                    }
                    room {
                        id
                    }
                    updated
                }
                ... on MemberRemoved {
                    actor {
                        id
                        username
                        avatar
                    }
                    id
                    member {
                        id
                        username
                        avatar
                    }
                    room {
                        id
                    }
                    updated
                }
                ... on MemberUpdated {
                    id
                    member {
                        id
                        username
                        avatar
                    }
                    room {
                        id
                    }
                    updated
                }
                ... on MusicReaction {
                    actor {
                        id
                        username
                        avatar
                    }
                    id
                    reaction
                    room {
                        id
                    }
                    track {
                        id
                        album
                        artist
                        bitRate
                        codec
                        composer
                        contributors {
                            id
                            username
                        }
                        coverArt {
                            full
                            thumb250
                            thumb500
                            thumb1200
                        }
                        created
                        date
                        duration
                        files {
                            bitRate
                            duration
                            key
                            size
                        }
                        genre
                        roomId
                        size
                        tags
                        title
                        track
                        updated
                        youtubeId
                    }
                    updated
                }
                ... on RequestAdded {
                    actor {
                        id
                        username
                        avatar
                    }
                    id
                    request {
                        id
                        user {
                            id
                            username
                            avatar
                        }
                        track {
                            id
                            album
                            artist
                            bitRate
                            codec
                            composer
                            contributors {
                                id
                                username
                            }
                            coverArt {
                                full
                                thumb250
                                thumb500
                                thumb1200
                            }
                            created
                            date
                            duration
                            files {
                                bitRate
                                duration
                                key
                                size
                            }
                            genre
                            roomId
                            size
                            tags
                            title
                            track
                            updated
                            youtubeId
                        }
                    }
                    room {
                        id
                    }
                    updated
                }
                ... on RequestRemoved {
                    actor {
                        id
                        username
                        avatar
                    }
                    id
                    request {
                        id
                        track {
                            id
                            album
                            artist
                            bitRate
                            codec
                            composer
                            contributors {
                                id
                                username
                            }
                            coverArt {
                                full
                                thumb250
                                thumb500
                                thumb1200
                            }
                            created
                            date
                            duration
                            files {
                                bitRate
                                duration
                                key
                                size
                            }
                            genre
                            roomId
                            size
                            tags
                            title
                            track
                            updated
                            youtubeId
                        }
                        user {
                            id
                            username
                            avatar
                        }
                        playTime
                    }
                    room {
                        id
                    }
                    updated
                }
                ... on RequestSkipped {
                    actor {
                        id
                        username
                        avatar
                    }
                    id
                    request {
                        id
                        track {
                            id
                            album
                            artist
                            bitRate
                            codec
                            composer
                            contributors {
                                id
                                username
                            }
                            coverArt {
                                full
                                thumb250
                                thumb500
                                thumb1200
                            }
                            created
                            date
                            duration
                            files {
                                bitRate
                                duration
                                key
                                size
                            }
                            genre
                            roomId
                            size
                            tags
                            title
                            track
                            updated
                            youtubeId
                        }
                        user {
                            id
                            username
                            avatar
                        }
                    }
                    room {
                        id
                    }
                    updated
                }
                ... on RequestStarted {
                    actor {
                        id
                        username
                        avatar
                    }
                    id
                    request {
                        id
                        track {
                            id
                            album
                            artist
                            bitRate
                            codec
                            composer
                            contributors {
                                id
                                username
                            }
                            coverArt {
                                full
                                thumb250
                                thumb500
                                thumb1200
                            }
                            created
                            date
                            duration
                            files {
                                bitRate
                                duration
                                key
                                size
                            }
                            genre
                            roomId
                            size
                            tags
                            title
                            track
                            updated
                            youtubeId
                        }
                        user {
                            id
                            username
                            avatar
                        }
                    }
                    room {
                        id
                    }
                    updated
                }
                ... on RoomUpdated {
                    actor {
                        id
                        username
                        avatar
                    }
                    id
                    room {
                        admins {
                            id
                            username
                            avatar
                        }
                        created
                        id
                        invites {
                            email
                            id
                            issuer {
                                id
                                username
                                avatar
                            }
                            user {
                                id
                                username
                                avatar
                            }
                        }
                        members {
                            id
                            username
                            avatar
                        }
                        name
                        spinning
                        topic
                        updated
                    }
                    updated
                    updates {
                        name
                        spinning
                        topic
                    }
                }
                ... on TracksAdded {
                    actor {
                        id
                        username
                        avatar
                    }
                    id
                    room {
                        id
                    }
                    tracks {
                        id
                        album
                        artist
                        bitRate
                        codec
                        composer
                        contributors {
                            id
                            username
                        }
                        coverArt {
                            full
                            thumb250
                            thumb500
                            thumb1200
                        }
                        created
                        date
                        duration
                        files {
                            bitRate
                            duration
                            key
                            size
                        }
                        genre
                        roomId
                        size
                        tags
                        title
                        track
                        updated
                        youtubeId
                    }
                    updated
                }
                ... on TracksRemoved {
                    actor {
                        id
                        username
                        avatar
                    }
                    id
                    room {
                        id
                    }
                    tracks {
                        id
                        album
                        artist
                        bitRate
                        codec
                        composer
                        contributors {
                            id
                            username
                        }
                        coverArt {
                            full
                            thumb250
                            thumb500
                            thumb1200
                        }
                        created
                        date
                        duration
                        files {
                            bitRate
                            duration
                            key
                            size
                        }
                        genre
                        roomId
                        size
                        tags
                        title
                        track
                        updated
                        youtubeId
                    }
                    updated
                }
                ... on TrackUpdated {
                    actor {
                        id
                        username
                        avatar
                    }
                    id
                    room {
                        id
                    }
                    track {
                        id
                        album
                        artist
                        bitRate
                        codec
                        composer
                        contributors {
                            id
                            username
                        }
                        coverArt {
                            full
                            thumb250
                            thumb500
                            thumb1200
                        }
                        created
                        date
                        duration
                        files {
                            bitRate
                            duration
                            key
                            size
                        }
                        genre
                        roomId
                        size
                        tags
                        title
                        track
                        updated
                        youtubeId
                    }
                    updated
                    updates {
                        tagsAdded
                        tagsRemoved
                    }
                }
            }
        }
    }
`

export default History
